/* -----------------Globals--------------- */
import { forwardRef } from "react";
import { Platform, type TextInput } from "react-native";

/* -----------------UI--------------- */
import { HelperText } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { useDevice } from "../../useDevice";
/* -----------------Child components--------------- */
import Box from "../Box";

import { isWeb } from "@memorang/helpers/platform";
import { useKeyboard } from "@react-native-community/hooks";
import { useAppTheme } from "../../useAppTheme";
import TextModeChatComposer from "../TextModeChatComposer";
/* -----------------Types--------------- */
import type { BottomAppBarProps } from "./types/props";

const isIOS = Platform.OS === "ios";

export const ChatBottomAppBar = forwardRef<TextInput, BottomAppBarProps>(
	(
		{
			searchQuery,
			interceptSearchQuery,
			searchPlaceholder,
			handleAbortSearch,
			searchContextMenu,
			disableSearch,
			isItemAnswered,
			showConversationMode = false,
			style,
		},
		_ref,
	) => {
		const { isMobile } = useDevice();
		const { keyboardShown } = useKeyboard();
		const theme = useAppTheme();

		return (
			<Box>
				<Box
					width="100%"
					justifyContent="flex-end"
					padding={16}
					backgroundColor={isWeb ? theme.colors.elevation.level1 : undefined}
					paddingBottom={keyboardShown || isIOS ? 16 : 8}
					flexGrow={1}
					{...style}
				>
					<Box
						style={{
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						{showConversationMode && (
							<Box width={"100%"}>
								<TextModeChatComposer
									textInputProps={{
										placeholder: `Ask ${searchPlaceholder}`,
									}}
									isVoiceModeEnabled={false}
									onAbortResponse={handleAbortSearch}
									interceptResponseQuery={interceptSearchQuery}
									inputQuery={searchQuery}
									disableSearch={disableSearch}
									isItemAnswered={isItemAnswered}
								/>

								{searchContextMenu && !isMobile && (
									<HelperText style={{ textAlign: "center" }} type="info">
										{searchContextMenu}
									</HelperText>
								)}
							</Box>
						)}
					</Box>
				</Box>
			</Box>
		);
	},
);
